// Ported from LC2 (src/features/loyaltyCloudApi/reviewsSlice.js) — only `getReviews` is
// consumed so far (StakeSaySection.js, see pages/Dashboard/StakeSay/). `createReview` and
// `editReview` (admin-only "Add review" modal / visibility toggle) are kept out for this
// pass — StakeSaySection.js is read-only (see its header comment) — add them back here,
// following the same injectEndpoints pattern, when that admin flow gets ported.
import {loyaltyCloudApi} from './apiSlice';

export const reviewsApi = loyaltyCloudApi.injectEndpoints({
    endpoints: (builder) => ({
        getReviews: builder.query({
            query: (params) => ({
                url: '/reviews/',
                method: 'get',
                params
            }),
            providesTags: (result) => {
                const baseTag = [{type: 'Reviews', id: 'LIST'}];

                if (result && Array.isArray(result) && result.length > 0) {
                    const reviewTags = result.map(({id}) => ({type: 'Reviews', id}));
                    return [...reviewTags, ...baseTag];
                }

                return baseTag;
            }
        })
    }),
    overrideExisting: false
});

export const {useGetReviewsQuery, useLazyGetReviewsQuery} = reviewsApi;
